module.exports = __webpack_public_path__ + "static/media/identity.f1439509.svg";